import { lazy, Suspense } from 'react'

const ImageEditorDialog = lazy(() => import('@/components/media/ImageEditorDialog'))

export default function LazyImageEditorDialog({ open, ...props }) {
  if (!open) {
    return null
  }

  return (
    <Suspense fallback={null}>
      <ImageEditorDialog open={open} {...props} />
    </Suspense>
  )
}
